import type { ObjectForm } from "@pdfking/forms"

// FileRange/FileScale both derive their value from the file_id chosen in the
// same row; this reads that sibling's input without each caller re-casting parent.
export const sibling_file_id = (parent: ObjectForm<Record<string, unknown>> | undefined): string =>
  String(parent?.results.file_id?.input ?? "")
